import { takeLatest, put, call, select } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  HOME_CONFIGURATION_GET,
  HOME_COURSE_LIST_GET,
  HOME_LAST_COURSES_GET,
  HOME_NEWS_LIST_GET,
  USEFUL_LINKS_GET,
} from '../actions/home';
import home from '../../api/home';
import courselist from '../../api/courselist';
import news from '../../api/news';

function* homeConfigurationGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(home.getConfiguration);
    yield put({ type: HOME_CONFIGURATION_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > home > homeConfigurationGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* homeConfigurationGetWatch() {
  yield takeLatest(HOME_CONFIGURATION_GET._REQUEST, homeConfigurationGet);
}

function* courseListGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data: response },
    } = yield call(courselist.getHomeCoursesList, {
      how_many: 7,
    });
    yield put({ type: HOME_COURSE_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > home > courseListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseListGetWatch() {
  yield takeLatest(HOME_COURSE_LIST_GET._REQUEST, courseListGet);
}

function* lastCoursesGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data: response },
    } = yield call(courselist.getCoursesList, {
      items_per_page: 3,
      completion_status: 'incomplete',
    });
    yield put({ type: HOME_LAST_COURSES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > home > lastCoursesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* lastCoursesGetWatch() {
  yield takeLatest(HOME_LAST_COURSES_GET._REQUEST, lastCoursesGet);
}

function* newsListGet({ filters, isPublic }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { authState: { isLogged } = {} } = yield select((state) => state.app);
    const { data: { data: response } = {} } = yield call(news.homeNewsListGet, {
      filters: { ...filters },
      isLogged,
      isPublic,
    });
    yield put({ type: HOME_NEWS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > home > homeNewsListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newsListGetWatch() {
  yield takeLatest(HOME_NEWS_LIST_GET._REQUEST, newsListGet);
}

function* usefulLinksGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(home.usefulLinksGet);
    yield put({ type: USEFUL_LINKS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > home > usefulLinksGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* usefulLinksGetWatch() {
  yield takeLatest(USEFUL_LINKS_GET._REQUEST, usefulLinksGet);
}

export default [
  homeConfigurationGetWatch(),
  courseListGetWatch(),
  lastCoursesGetWatch(),
  newsListGetWatch(),
  usefulLinksGetWatch(),
];
